import { Dialog } from '@mui/material'
import usePaymentContext from '../hook/usePaymentContext'
import { SplitPaymentContainer } from './splitPaymentDialog/SplitPayment'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { SinglePaymentContainer } from '../singlePayment/SinglePayment'
import CloseButton from 'components/Dialog/CloseDialogButton'

interface IPaymentDialog {
    open: boolean
    onCloseDialogWithReset: () => void
}

function PaymentProcessDialog({
    open,
    onCloseDialogWithReset,
}: IPaymentDialog) {
    const { isProcessing, isSplitPayment } = usePaymentContext()
    const { isMobile } = useScreenSize()

    return (
        <>
            <Dialog
                open={open}
                onClose={() => {
                    if (!isProcessing) onCloseDialogWithReset()
                }}
                fullWidth
                maxWidth="lg"
                fullScreen={isMobile}
            >
                {!isMobile && (
                    <CloseButton
                        dialogName="payment dialog"
                        onClick={() => {
                            if (!isProcessing) onCloseDialogWithReset()
                        }}
                    />
                )}
                {/* Split payment uses the same ui for both screen size */}
                {isSplitPayment ? (
                    <SplitPaymentContainer />
                ) : (
                    <SinglePaymentContainer />
                )}
            </Dialog>
        </>
    )
}
export default PaymentProcessDialog
